import React from "react";
import Grid from "@mui/material/Grid";
import { Box, Card } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import Typography from "@mui/material/Typography";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronsRight } from "@fortawesome/pro-solid-svg-icons";
import { useContentByStatus } from "../creatorServices";

const useStyles = makeStyles(theme => ({
  root: {
    // minHeight: 185,
    height: "100%",
    width: "100%",
    padding: theme.spacing(4),
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    borderRadius: 20,
    color: theme.palette.secondary.contrastText,
    display: "flex",
    justifyContent: "flex-start",
    flexDirection: "column",
  },

  count: {
    marginRight: theme.spacing(1),
  },

  h1: {
    // fontSize: "6.0rem",
    fontSize: "3.8rem",
    fontWeight: "bold",
    color: theme.palette.primary.main,
  },

  h4: {
    // fontSize: "1.8rem",
    fontSize: "1.4rem",
    lineHeight: "2.2rem",
    fontWeight: "bold",
    color: theme.palette.primary.main,
  },

  body1: {
    fontSize: "1.2rem",
    textTransform: "uppercase",
  },

  body2: {
    fontSize: "1.2rem",
    lineHeight: "1.8rem",
    fontStyle: "italic",
  },

  icon: {
    fontSize: "0.9rem",
    marginTop: 2,
    marginLeft: 5,
    color: theme.palette.primary.main,
  },
}));

const PendingItemsCard = () => {
  const classes = useStyles();
  const results = useContentByStatus({ status: "pending", limit: "all" });

  return (
    <Link to="/creator/organize?view=review,pending">
      <Card classes={{ root: classes.root }}>
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item>
            <Typography
              variant="h4"
              component="span"
              classes={{ h4: classes.h4 }}
            >
              Pending Files
            </Typography>
          </Grid>
        </Grid>

        {results.isSuccess ? (
          <Box mt="20px" display="flex" flexDirection="column">
            <Typography
              variant="h1"
              component="p"
              classes={{ root: classes.count, h1: classes.h1 }}
            >
              {results.data.count.toLocaleString()}
            </Typography>

            <Box display="flex" alignItems="center">
              <Typography
                component="p"
                variant="h4"
                classes={{ h4: classes.h4 }}
              >
                Review
              </Typography>
              <FontAwesomeIcon
                className={classes.icon}
                icon={faChevronsRight}
              />
            </Box>
          </Box>
        ) : (
          <Box>
            <Typography
              variant="h4"
              component="span"
              classes={{ h4: classes.h4 }}
            >
              Loading...
            </Typography>
          </Box>
        )}
      </Card>
    </Link>
  );
};

export default PendingItemsCard;
